import { render } from "./Supplementplus20250114.vue?vue&type=template&id=2ff922b4&scoped=true"
import script from "./Supplementplus20250114.vue?vue&type=script&lang=js"
export * from "./Supplementplus20250114.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-2ff922b4"

export default script